import { useContext } from "react";
import Card from "../../../components/card/card";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../../context/user-appointment-context";

const PhoneVerification = () => {
  const {
    state: { activeStep },
    userDispatcher,
  } = useContext(UserAppointmentContext);
  return (
    <Card
      title={"We need your phone number information"}
      description={
        "Phone number details would be required to pull data from our system. Please press continue to give a phone number with yor email account."
      }
      btnTitle={"Continue"}
      onHandleClick={() =>
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
          payload: activeStep + 1,
        })
      }
      progress={activeStep * 5}
    />
  );
};

export default PhoneVerification;
